<template>
  <div>
    <el-card>
      <div style="display:flex; justify-content:space-between; align-items:center;">
        <h3>足迹内容管理</h3>
        <!-- 搜索框 -->
        <div style="display:flex; gap:10px;">
          <el-input 
            v-model="searchPhone" 
            placeholder="输入用户手机号精确查找" 
            clearable 
            style="width:220px;"
            @keyup.enter.native="handleSearch"
          ></el-input>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>
      </div>

      <el-table :data="tableData" border stripe style="margin-top:15px;width:100%">
        <el-table-column prop="id" label="足迹ID" width="100" />
        <el-table-column prop="userId" label="用户手机号" width="130" />
        <el-table-column prop="cityName" label="城市" width="120"/>
        <el-table-column prop="arriveTime" label="抵达时间" width="130"/>
        
        <!-- 👇 文字列：加上点击事件 -->
        <el-table-column label="文字内容" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="content-click" @click="showDetail(scope.row)">
              {{ scope.row.content || '无' }}
            </span>
          </template>
        </el-table-column>
        
        <!-- 👇 图片列：+N 可点击 -->
        <el-table-column label="图片" width="220">
          <template slot-scope="scope">
            <template v-if="scope.row.imgList && scope.row.imgList.length > 0">
              <el-image
                v-for="(img, idx) in scope.row.imgList.slice(0, 3)"
                :key="idx"
                :src="img"
                :preview-src-list="scope.row.imgList"
                style="width:60px;height:60px;margin-right:4px;object-fit:cover;border-radius:4px;"
              ></el-image>
              <span v-if="scope.row.imgList.length > 3" class="more-img" @click="showDetail(scope.row)">
                +{{ scope.row.imgList.length - 3 }}
              </span>
            </template>
            <span v-else style="color:#999;">无图</span>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间" width="170"/>
        
        <!-- 👇 操作列加宽，增加查看详情按钮 -->
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="showDetail(scope.row)">查看详情</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        style="margin-top:15px;text-align:right;"
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="fetchContentList"
      />
    </el-card>

    <!-- 👇 新增：详情弹窗 -->
    <el-dialog title="足迹完整详情" :visible.sync="detailDialogVisible" width="700px">
      <div v-if="currentRow" class="detail-container">
        <!-- 文字区域 -->
        <div class="detail-section">
          <h4>文字内容：</h4>
          <div class="text-content">{{ currentRow.content || '暂无文字内容' }}</div>
        </div>
        
        <!-- 图片区域 -->
        <div class="detail-section" style="margin-top: 20px;">
          <h4>图片附件（共 {{ currentRow.imgList ? currentRow.imgList.length : 0 }} 张）：</h4>
          <div class="img-list" v-if="currentRow.imgList && currentRow.imgList.length > 0">
            <el-image
              v-for="(img, idx) in currentRow.imgList"
              :key="idx"
              :src="img"
              :preview-src-list="currentRow.imgList"
              fit="cover"
              class="detail-img"
            ></el-image>
          </div>
          <span v-else style="color: #999;">无图片</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import adminRequest from '@/utils/adminRequest'
export default {
  data() {
   return {
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchPhone: '',
      detailDialogVisible: false, // 👈 新增：控制弹窗显示
      currentRow: null            // 👈 新增：当前查看的数据
    }
  },
  watch: {
    '$route.query.phone': {
      handler(newVal) {
        this.searchPhone = newVal || '';
        this.currentPage = 1;
        this.fetchContentList();
      },
      immediate: true
    }
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.fetchContentList();
    },
    resetSearch() {
      this.searchPhone = '';
      this.currentPage = 1;
      if (this.$route.query.phone) {
        this.$router.replace({ path: '/sys-console-x9/content' });
      } else {
        this.fetchContentList();
      }
    },
    async fetchContentList() {
      try {
        const params = { 
          page: this.currentPage, 
          pageSize: this.pageSize 
        };
        if (this.searchPhone && this.searchPhone.trim() !== '') {
          params.phone = this.searchPhone.trim();
        }

        const res = await adminRequest.get('/footprintList', { params });
        
        this.total = res.data?.total || 0
        this.tableData = (res.data?.list || []).map(item => ({
          id: item.id,
          userId: item.user_id,
          cityName: item.city,
          arriveTime: item.arrive_time,
          content: item.content,
          imgList: item.imgList || [],
          createTime: item.create_time
        }))
      } catch (err) {
        console.error('获取足迹列表失败：', err)
        this.tableData = []
      }
    },
    // 👇 打开详情弹窗
    showDetail(row) {
      this.currentRow = row;
      this.detailDialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定要删除这条足迹记录吗？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await adminRequest.delete('/footprintDelete', {
            data: { id: row.id }
          })
          if (res.success) {
            this.$message.success('删除成功')
            this.fetchContentList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (err) {
          console.error(err)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
/* 文字列样式：鼠标变手型 */
.content-click {
  color: #409eff;
  cursor: pointer;
}
.content-click:hover {
  text-decoration: underline;
}
/* +N 样式 */
.more-img {
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
}
.more-img:hover {
  text-decoration: underline;
}

/* 👇 弹窗内部样式 👇 */
.detail-section h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 15px;
}
/* 文字内容框：长文内部滚动 */
.text-content {
  background: #f5f7fa;
  padding: 15px;
  border-radius: 8px;
  line-height: 1.7;
  color: #555;
  font-size: 14px;
  white-space: pre-wrap; /* 保留换行符 */
  word-break: break-word; /* 防止长英文字母撑爆 */
  max-height: 250px;
  overflow-y: auto;
}
/* 图片列表：网格排列，超长内部滚动 */
.img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  max-height: 320px;
  overflow-y: auto; 
  padding: 5px;
}
.detail-img {
  width: 130px;
  height: 130px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  object-fit: cover;
  cursor: zoom-in;
}
</style>